<script lang="ts">
	import {getContext} from "svelte";
    import {Utils} from "../../util";
    import type {Context} from "svelte-simple-modal/types/Modal.svelte";
    import {myStore, uploadProgressStore} from "../../stores";

	export let title: string;
	export let message: string;

    export let data:any; //all data for upload;
	export let onClose: () => void;

    let selectedEmail = null;

    let otherEmail = null;

	const { close } = getContext<Context>('simple-modal');

	function closeMe() {
        uploadProgressStore.update($uploadProgressStore => ({
            value:0,
            data:null
        }));
		close();
		onClose?.();
    }

    function submitForm(){
        console.log("submit via api...",data);

        if(!selectedEmail){
            console.log("email missing!");
            return;

        }

        console.log("selectedEmail value = ",selectedEmail)
        console.log("otherEmail = ", otherEmail);

        if(selectedEmail != 'other') {

            data.email = selectedEmail;
        }else{
            data.email = otherEmail;
        }
        console.log("final data:::::", data);



        uploadProgressStore.update($uploadProgressStore => ({
            value:0,
            data:data
        }));
        close();
}
</script>

<div class="modal" tabindex="-1" style="display: block;" aria-modal="true" role="dialog">
    <div class="modal-header">
        <div class="modal-title">
            {#if data.pactPerson.length > 1}
            Veuillez choisir la personne qui effectuera l'authentification à deux facteurs
            {/if}
        </div>
        <button type="button" class="modal-close" on:click={closeMe}>
            <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.65685 2.43466e-05L6.60183 0.945001L0.944977 6.60186L0 5.65688L5.65685 2.43466e-05Z" fill="#F8F7F7"/>
                <path d="M5.65685 6.60183L6.60183 5.65685L0.944977 0L0 0.944977L5.65685 6.60183Z" fill="#F8F7F7"/>
            </svg>
        </button>
    </div>
    <div class="modal-body">
        {#each data.pactPerson as person}

            {#if person?.email && person?.email != null}
        <div style="display:flex">
            <label class="form-control" for="receiver">
                <input type="radio" id="receiver" bind:group={selectedEmail}  name="receiverEmail" value="{person.email}"  />
                {person.email}
            </label>
        </div>
                {/if}
        {/each}
        <div style="display:flex">
            <label class="form-control" for="other-receiver">
                <input type="radio" id="other-receiver" bind:group={selectedEmail}  name="receiverEmail" value="other"  />
                autre
            </label>
        </div>

        {#if selectedEmail === 'other'}

            <div class="custom-col-12">
                <input type="email" class="w-100" class:error={!selectedEmail || selectedEmail === ''} bind:value={otherEmail} required placeholder="Email"/>
            </div>

            {/if}

        <p style="font-size:16px;">Êtes-vous sûr de vouloir envoyer le formulaire?</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="modal-button" disabled={!selectedEmail}
                on:click={submitForm}>
            <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M49.5485 3L23.9473 28.6012" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M49.5476 3L33.256 49.5476L23.9464 28.6012L3 19.2917L49.5476 3Z" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            envoyer
        </button>
    </div>
</div>

<style lang="scss">
  .modal {
    background: #FFFFFF;
    border-radius: 16px;

    padding: 50px;

    /* 600px, 900px, 1200px, and 1800px */
    @media (max-width: 600px) {
      padding: 20px;
    }

    .modal-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 25px;
      align-items: baseline;

      .modal-title {
        //font-family: 'Open Sans', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        color: $primary-color;
      }

      button.modal-close {

        margin-left:2rem;
        border-radius: 9px;
        border: 0;
        /* all: unset; */
        cursor: pointer;
        background: $secondary-color;
        display: flex;
        padding: 0.75rem;


          //line-height: 0;
          svg {
            transform: scale(2);
          }


      }
    }
    .modal-body {
      margin-bottom: 20px;
      color:$primary-color;
      /* 600px, 900px, 1200px, and 1800px */
      @media (max-width: 600px) {
        margin-bottom: 30px;
      }
    }

    .modal-footer {
      display: flex;
      justify-content: center;

      .modal-button {
        all: unset;
        cursor: pointer;
        color:white;
        background: $secondary-color;
        border-radius: 9px !important;
        //font-family: 'Open Sans', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 23px;
        padding: 10px 85px;
        display:flex;
        align-items: center;
        justify-content: center;
        width:100%;

        svg{
          width:30px;
          margin-right:1rem;
        }

        /* 600px, 900px, 1200px, and 1800px */
        @media (max-width: 600px) {
          padding: 10px 20px;
        }

        &:hover {
          background: darken($secondary-color, 10%);
        }
      }
    }
  }

  .form-control:has( input[type="radio"]:checked){

    background:$secondary-color;
    color: $white;

  }
  .form-control {

    //font-size: 2rem;
    font-weight: bold;
    //line-height: 1.1;
    display:flex;
    align-items: center;
    gap: 0.5em;
    //box-sizing: border-box;
    background: $form-grey;
    margin-bottom:1rem;
    padding:0.5rem;
    width:100%;
    border-radius: 9px;
    color:$primary-color!important;
  }

  .form-control:hover{
    background:$secondary-color;
    color:$white;
  }

  input[type='email'] {
    color:$primary-color!important;
    background:$form-grey!important;
  }

  input[type='email']::placeholder{
    color:$primary-color!important;
  }

  input[type="radio"] {
    box-sizing: border-box;
    appearance: none;
    background-color: $white;
    margin: 0;
    font: inherit;
    color: currentColor;
    width: 1.0em;
    height: 1.0em;
    border: 0.15em solid $white;
    border-radius: 50%;
    //transform: translateY(-0.075em);
    display: grid;
    place-content: center;
    /* Add if not using autoprefixer */
    -webkit-appearance: none;

  }

  input[type="radio"]::before {
    content: "";
    width: 1em;
    height: 1em;
    border-radius: 50%;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em $white;
    background-color: $white;
  }
  input[type="radio"]:checked::before {
    transform: scale(1);
    background-color: $secondary-color;
  }

  input[type="radio"]:checked{

    background-color:$secondary-color;
  }

</style>
